// src/components/common/StudentHeader.jsx
import React from "react";
import "./Header.css";
import StudentProfileLogoutIcon from "./StudentProfileLogoutIcon";

const StudentHeader = ({ title, onMenuClick, sidebarOpen, notificationCount }) => {
  return (
    <header className="header-container">

     {!sidebarOpen && (
  <button className="header-menu-btn" onClick={onMenuClick}>
    <span></span>
    <span></span>
    <span></span>

    {/* {notificationCount > 0 && (
      <span
        style={{
          position: "absolute",
          top: "-6px",
          right: "-14px",
          background: "#e53935",
          color: "#fff",
          fontSize: "9px",
          fontWeight: "700",
          minWidth: "16px",
          height: "16px",
          borderRadius: "999px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 3px",
          border: "2px solid #f8fafc",
          pointerEvents: "none",
          lineHeight: 1,
          zIndex: 9999,
        }}
      >
        {notificationCount > 99 ? "99+" : notificationCount}
      </span>
    )} */}
  </button>
)}

      <h2 className="header-title">{title}</h2>

      <div className="header-profile">
        <StudentProfileLogoutIcon />
      </div>

    </header>
  );
};

export default StudentHeader;